import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "backdrop", "toggleIcon"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasSidebarTarget || !this.hasBackdropTarget) return

    this.sidebarTarget.classList.add('desktop-sidebar--open')
    this.backdropTarget.classList.add('desktop-sidebar-backdrop--visible')
    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.remove('fa-layer-group')
      this.toggleIconTarget.classList.add('fa-times')
    }
    this.isOpen = true
  }

  close() {
    if (!this.hasSidebarTarget || !this.hasBackdropTarget) return

    this.sidebarTarget.classList.remove('desktop-sidebar--open')
    this.backdropTarget.classList.remove('desktop-sidebar-backdrop--visible')
    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.remove('fa-times')
      this.toggleIconTarget.classList.add('fa-layer-group')
    }
    this.isOpen = false
  }
}
